import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import {
  ActionsGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FlatButton,
  Input,
  TitleText,
  WaitingButton,
} from "@evergis/ui";

import { useDialogReset, useDialogInfo } from "../../../hooks/useDialogs";
import { useImageAttribute } from "./useImageAttribute";

export const AddImageAttribute: FC = () => {
  const { t } = useTranslation();
  const cancelDialog = useDialogReset();
  const dialogInfo = useDialogInfo();
  const dialogOptions = dialogInfo && dialogInfo.options;
  const { imageUrl, changeImageUrl, addImageUrl } = useImageAttribute(dialogOptions);

  return (
    <Dialog isOpen maxWidth="40rem" onCloseRequest={cancelDialog}>
      <DialogTitle>
        <TitleText>{t("addImageAttribute.dialogHeader", { ns: "dialogs" })}</TitleText>
      </DialogTitle>
      <DialogContent>
        <Input
          autoFocus
          width="32.875rem"
          label={t("addImageAttribute.imageLink", { ns: "dialogs" })}
          value={imageUrl}
          onChange={changeImageUrl}
        />
      </DialogContent>
      <DialogActions>
        <ActionsGroup>
          <WaitingButton primary onClick={addImageUrl} disabled={!imageUrl} isWaiting={false}>
            {t("actions.add", { ns: "common" })}
          </WaitingButton>
          <FlatButton onClick={cancelDialog}>{t("actions.cancel", { ns: "common" })}</FlatButton>
        </ActionsGroup>
      </DialogActions>
    </Dialog>
  );
};
